// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1HoBE_vuarqfJpIWDRqZxm{width:100%;height:100%;display:flex;flex-direction:column}._1kzuJ9V3B_5-w7r2u1BNjY._1kzuJ9V3B_5-w7r2u1BNjY._1kzuJ9V3B_5-w7r2u1BNjY{width:100%;margin-left:auto;margin-right:auto;margin-top:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_1HoBE_vuarqfJpIWDRqZxm",
	"buttonPlaceholder": "_1kzuJ9V3B_5-w7r2u1BNjY"
};
module.exports = ___CSS_LOADER_EXPORT___;
